// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* "Associate an existing device" popup: header, fixed warning + search, scrolling list.
 * The host is the modal page (.ion-page, flex column): it starts from the top. */
:host {
  justify-content: flex-start;
  font-family: var(--ion-font-family, inherit);
  background: var(--ion-background-color, #fff);
}

.ad-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 0 0 auto;
  padding: 16px 12px 12px 20px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.ad-header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
}

.ad-close {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium-shade);
  line-height: 0;
  cursor: pointer;
}
.ad-close ion-icon {
  display: block;
  font-size: 21px;
}
.ad-close:hover, .ad-close:focus-visible {
  outline: none;
  background: rgba(var(--ion-color-medium-rgb), 0.12);
}

.ad-top {
  flex: 0 0 auto;
  display: grid;
  gap: 12px;
  padding: 16px 20px 12px;
}

.ad-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--ion-color-warning-shade);
  background: rgba(var(--ion-color-warning-rgb), 0.12);
}
.ad-notice ion-icon {
  flex-shrink: 0;
  font-size: 20px;
}

/* Same search look as the user directory */
.ad-search {
  height: 44px;
  min-height: 0;
  padding: 0;
  --border-radius: 10px;
  --box-shadow: none;
  --background: rgba(var(--ion-color-medium-rgb), 0.1);
}
.ad-search ::ng-deep .searchbar-input-container,
.ad-search ::ng-deep .searchbar-input {
  height: 100%;
  min-height: 0;
}
.ad-search ::ng-deep .searchbar-search-icon {
  top: 50%;
  transform: translateY(-50%);
}

.ad-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 20px calc(20px + var(--ion-safe-area-bottom));
}

.ad-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.2);
  border-radius: 12px;
  overflow: hidden;
}
.ad-list li + li {
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);
}

/* Whole row is the action: picking a device moves it into this environment */
.ad-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 12px 12px 14px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.ad-row:hover, .ad-row:focus-visible {
  outline: none;
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}
.ad-row:hover .ad-row__add, .ad-row:focus-visible .ad-row__add {
  color: var(--ion-color-primary-contrast);
  background: var(--ion-color-primary);
}
.ad-row__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}
.ad-row__icon ion-icon {
  font-size: 20px;
}
.ad-row__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-width: 0;
}
.ad-row__name {
  font-size: 15px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.ad-row__detail {
  font-size: 13px;
  color: var(--ion-color-medium-shade);
  overflow-wrap: anywhere;
}
.ad-row__model {
  font-size: 12.5px;
  color: var(--ion-color-medium);
}
.ad-row__add {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  line-height: 0;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  transition: background-color 0.15s ease, color 0.15s ease;
}
.ad-row__add ion-icon {
  display: block;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popup-associate-existing-sinapsi-device/popup-associate-existing-sinapsi-device.scss"],"names":[],"mappings":"AAAA;iFAAA;AAEA;EACE,2BAAA;EACA,4CAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,4BAAA;EACA,gEAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;AAGE;EAEE,aAAA;EACA,mDAAA;AAFJ;;AAMA;EACE,cAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;EACA,oDAAA;AAHF;AAKE;EACE,cAAA;EACA,eAAA;AAHJ;;AAOA,2CAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,oDAAA;AAJF;AAME;;EAEE,YAAA;EACA,aAAA;AAJJ;AAOE;EACE,QAAA;EACA,2BAAA;AALJ;;AASA;EACE,cAAA;EACA,gBAAA;EACA,wDAAA;AANF;;AASA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wDAAA;EACA,mBAAA;EACA,gBAAA;AANF;AAQE;EACE,6DAAA;AANJ;;AAUA,6EAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAPF;AASE;EAEE,aAAA;EACA,oDAAA;AARJ;AAUI;EACE,wCAAA;EACA,oCAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oDAAA;AAVJ;AAYI;EACE,eAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AAZJ;AAeE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAbJ;AAgBE;EACE,eAAA;EACA,oCAAA;EACA,uBAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,8BAAA;AAfJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,+BAAA;EACA,oDAAA;EACA,yDAAA;AAhBJ;AAkBI;EACE,cAAA;EACA,eAAA;AAhBN","sourcesContent":["/* \"Associate an existing device\" popup: header, fixed warning + search, scrolling list.\n * The host is the modal page (.ion-page, flex column): it starts from the top. */\n:host {\n  justify-content: flex-start;\n  font-family: var(--ion-font-family, inherit);\n  background: var(--ion-background-color, #fff);\n}\n\n.ad-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex: 0 0 auto;\n  padding: 16px 12px 12px 20px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  h2 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 1.35;\n  }\n}\n\n.ad-close {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium-shade);\n  line-height: 0;\n  cursor: pointer;\n\n  ion-icon {\n    display: block;\n    font-size: 21px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    background: rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n}\n\n.ad-top {\n  flex: 0 0 auto;\n  display: grid;\n  gap: 12px;\n  padding: 16px 20px 12px;\n}\n\n.ad-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--ion-color-warning-shade);\n  background: rgba(var(--ion-color-warning-rgb), 0.12);\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 20px;\n  }\n}\n\n/* Same search look as the user directory */\n.ad-search {\n  height: 44px;\n  min-height: 0;\n  padding: 0;\n  --border-radius: 10px;\n  --box-shadow: none;\n  --background: rgba(var(--ion-color-medium-rgb), 0.1);\n\n  ::ng-deep .searchbar-input-container,\n  ::ng-deep .searchbar-input {\n    height: 100%;\n    min-height: 0;\n  }\n\n  ::ng-deep .searchbar-search-icon {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n.ad-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 0 20px calc(20px + var(--ion-safe-area-bottom));\n}\n\n.ad-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.2);\n  border-radius: 12px;\n  overflow: hidden;\n\n  li + li {\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n}\n\n/* Whole row is the action: picking a device moves it into this environment */\n.ad-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 12px 12px 14px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    background: rgba(var(--ion-color-primary-rgb), 0.06);\n\n    .ad-row__add {\n      color: var(--ion-color-primary-contrast);\n      background: var(--ion-color-primary);\n    }\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n\n    ion-icon {\n      font-size: 20px;\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 15px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n  }\n\n  &__detail {\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n    overflow-wrap: anywhere;\n  }\n\n  &__model {\n    font-size: 12.5px;\n    color: var(--ion-color-medium);\n  }\n\n  &__add {\n    display: grid;\n    place-items: center;\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    line-height: 0;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n    transition: background-color 0.15s ease, color 0.15s ease;\n\n    ion-icon {\n      display: block;\n      font-size: 18px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
